class DocumentReferenceDownloadRequestValidation {
    constructor(
        private _docRefIdError: string = '',
        private _constraintsError: string = '',
        private _isError: boolean = false
    ) {}
    set docRefIdError(value: string) {
        this._docRefIdError = value
    }
    get docRefIdError(): string {
        return this._docRefIdError
    }
    set constraintsError(value: string) {
        this._constraintsError = value
    }
    get constraintsError(): string {
        return this._constraintsError
    }
    set isError(value: boolean) {
        this._isError = value;
    }
    get isError(): boolean {
        return this._isError
    }
}
export default DocumentReferenceDownloadRequestValidation